import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
  },
  sectionTitle: {
    fontWeight: 600,
  },
  switchLabel: {
    marginTop: theme.spacing(1),
  },
  radioGroup: {
    marginTop: theme.spacing(1),
  },
  autocomplete: {
    marginTop: theme.spacing(2),
  },
  inlineBox: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  emphasisColor: {
    backgroundColor: theme.palette.background.default,
  },
}))

export default useStyles
